/**
 * Author(s) : Shakthi Priya, Jerry Oswin
 * Pupose : This is header component containing Theme and Timer. Responsiveness is handled.
 */
import styles from './Header.module.scss';
import { ToggleEffect, Timer } from '../../components';
import { HOME_ROUTE, VIEWPORT_BREAKPOINTS, THEME } from '../../constants';
import lightModeLogo from '../../assets/logos/lightModeLogo.png';
import darkModeLogo from '../../assets/logos/darkModeLogo.png';
import Logo from '../../components/logo/Logo';
import React from 'react';
import PropTypes from 'prop-types';
import { Turn as Hamburger } from 'hamburger-react';
import useViewport from '../../hooks/useViewport';
import { NavLink } from 'react-router-dom';

const Header = (props) => {
  const { handleTheme, theme, isHamburgerOpen, setHamburgerOpen } = props;

  // To get viewport width
  const { viewportWidth } = useViewport();

  return (
    <div className={styles.header}>
      <div className={styles.menuCircle}></div>
      {viewportWidth <= VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES && (
        <div className={styles.hamburgerContainer}>
          <Hamburger
            size={25}
            rounded
            toggled={isHamburgerOpen}
            toggle={setHamburgerOpen}
          />
        </div>
      )}
      <div className={styles.headerRight}>
        {viewportWidth <= VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES && (
          <NavLink to={HOME_ROUTE} className={styles.logoContainer}>
            <Logo
              image={
                theme === THEME.LIGHT ? lightModeLogo : darkModeLogo
              }></Logo>
          </NavLink>
        )}
        <div className={styles.timer}>
          <Timer />
        </div>
        {viewportWidth > VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES && (
          <ToggleEffect handleTheme={handleTheme} theme={theme}></ToggleEffect>
        )}
      </div>
    </div>
  );
};

export default React.memo(Header);

Header.propTypes = {
  handleTheme: PropTypes.func,
  theme: PropTypes.string,
};
